import {
  ToggleButton,
  ToggleButtonGroup,
  FormControl,
  FormLabel,
} from "@mui/material";

import { TypedOption } from "api/common/types/common.types";
import { useFieldContext } from "components/Forms/AppForm";

import ErrorMessage from "../../helpers/ErrorMessage";

interface ToggleGroupSelectProps<T> {
  label: string;
  options: TypedOption<T>[];
  required?: boolean;
  disabled?: boolean;
}

const ToggleGroupSelect = <T extends string>({
  label,
  options,
  required,
  disabled = false,
}: ToggleGroupSelectProps<T>) => {
  const field = useFieldContext<string>();

  return (
    <FormControl fullWidth disabled={disabled}>
      <FormLabel required={required}>{label}</FormLabel>

      <ToggleButtonGroup
        value={field.state.value}
        exclusive
        color={"primary"}
        fullWidth
        onChange={(_, newValue) => {
          if (newValue !== null) field.handleChange(newValue);
        }}
        disabled={disabled}
      >
        {options.map((option) => (
          <ToggleButton
            key={option.value}
            value={option.value}
            disableRipple
            color={"primary"}
            sx={{
              fontSize: "12px",
              textTransform: "none",
            }}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      <ErrorMessage />
    </FormControl>
  );
};

export default ToggleGroupSelect;
